import axios from "axios";
import * as paths from "../constants/paths";

const instance = axios.create({
  baseURL: paths.API_OPENSEARCH_URL,
  headers: {
    "Content-type": "application/json",
  },
  timeout: 55000,
});

// Mirrors the interceptor in http.js. See that file for the full rationale —
// the short version: pulling the token at module-load time froze a stale value
// into the axios instance, so every post-login request still shipped the old
// header. The interceptor reads localStorage fresh on each request, and
// preserves any explicit per-request Authorization override (including "").
instance.interceptors.request.use((config) => {
  if (config.headers?.Authorization === undefined) {
    const token = localStorage.getItem("authToken");
    if (token) {
      config.headers = config.headers || {};
      config.headers.Authorization = token;
    }
  }
  return config;
});

export default instance;
